import React, { FC, createContext, useState } from 'react';
import useLocalStorage from '@vh/utility/useLocalStorage';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { virtualHumanTypeSelector } from '@vh/slices/VirtualHumanSlice';

export const MicBehaviorContext = createContext({
  micActive: false,
  setMicActive: /** @type {(newVal: boolean) => void} */ (newVal) => {},
  micBehavior: '',
  setMicBehavior: /** @type {(newVal: string) => void} */ (newVal) => {},
});

/**
 * @type {FC<{children: React.ReactNode, defaultMicBehavior: 'open' | 'push_to_talk' | null}> }
 */
export const MicBehaviorProvider = ({ children, defaultMicBehavior }) => {
  const [micBehavior, setMicBehavior] = useLocalStorage('vhMicBehavior', '');

  const [micActive, setMicActive] = useState(false);

  const vhType = useSelector(virtualHumanTypeSelector);
  let processedMicBehavior =
    micBehavior || defaultMicBehavior || 'push_to_talk';
  // remove this check once record_and_send supported by branching
  if (vhType === 'branching' && processedMicBehavior === 'record_and_send') {
    processedMicBehavior = 'push_to_talk';
  }

  return (
    <MicBehaviorContext.Provider
      value={{
        micActive,
        setMicActive,
        micBehavior: processedMicBehavior,
        setMicBehavior,
      }}
    >
      {children}
    </MicBehaviorContext.Provider>
  );
};

MicBehaviorProvider.propTypes = {
  children: PropTypes.node.isRequired,
  defaultMicBehavior: PropTypes.oneOf(['open', 'push_to_talk']),
};

export default MicBehaviorProvider;
